import { HttpHeaders } from '@angular/common/http';

export const environment = {
  production: true,
  requestHeaders: new HttpHeaders(),
  serverUrl: 'SERVER_URL',
  appUrl: 'SERVER_URL',
  playerUrl: 'SERVER_URL',
  mediaStorageUrl:'MEDIA_STORAGE_URL'
 
}